// バリデーションメッセージ
import React from 'react';

interface Props {
  message?: string;
}

const ValidMessage: React.FC<Props> = ({ message }) => {
  return (
    <>
      {message && (
        <span className="is-invalid">
          <strong>{message}</strong>
        </span>
      )}
    </>
  );
};

export default ValidMessage;
